// text.tsx
import * as React from "react";
import styled, { css } from "react-emotion";
import * as bp from "./layout/breakpoints";
import * as sp from "./layout/spacing";
import { h1, h2, h3, h4, paragraph, small, italic, strong } from "./typefaces";
import { primaryColors, greyColors } from "./colors";
/** Headings */
export const H1 = styled("h1") `
  ${h1};
  color: ${primaryColors.zuerichBlue};
  ${sp.pa0};
  ${sp.ma0};
`;
export const H2 = styled("h2") `
  ${h2};
  color: ${primaryColors.zuerichBlue};
  ${sp.pa0};
  ${sp.ma0};
`;
export const H3 = styled("h3") `
  ${h3};
  color: ${primaryColors.darkGrey};
  ${sp.pa0};
  ${sp.ma0};
`;
export const H4 = styled("h4") `
  ${h4};
  color: ${primaryColors.darkGrey};
  ${sp.pa0};
  ${sp.ma0};
`;
/** Paragraph */
export const Small = styled("small") `
  ${small};
  color: ${greyColors["700"]};
  ${sp.pa0};
  ${sp.ma0};
`;
export const Paragraph = styled("p") `
  ${paragraph};
  color: ${greyColors["700"]};
  ${sp.ma0};
  ${sp.pa0};
`;
/** Inline styles */
export const Strong = styled("strong") `
  ${paragraph};
  ${strong};
  color: ${primaryColors.darkGrey};
`;
export const Em = styled("em") `
  ${paragraph};
  ${italic};
  color: ${greyColors["700"]};
`;
export const InlineLinkAnchor = styled("a") `
  ${paragraph};
  color: ${primaryColors.zuerichBlue};
  display: inline;
  text-decoration: none;
  box-shadow: ${primaryColors.zuerichBlue} 0px 1px 0px 0px;
  transition: box-shadow ease 0.3s;
  &:hover {
    cursor: pointer;
    box-shadow: ${primaryColors.zuerichBlue} 0px 2px 0px 0px;
  }
`;
/** List */
export const definitionList = css `
  position: relative;
  ${sp.pa0};
  ${sp.ma0} display: block;
  list-style-type: none;
`;
export const orderedList = css `
  ${definitionList};
  ${sp.pv0};
  ${sp.pl2};
`;
export const unorderedList = css `
  ${definitionList};
  ${sp.pa0};
`;
export const definitionListItem = css `
  ${paragraph};
  color: ${greyColors["700"]};
  ${sp.pa0};
  ${sp.ma0};
  list-style-type: none;
`;
export const orderedListItem = css `
  ${definitionListItem};
  ${sp.pa0};
  list-style-type: decimal;
`;
export const unorderedListItem = css `
  ${definitionListItem};
  ${sp.pa0};
  ${sp.pl3};
  list-style: none;
  &:before {
    content: "\\2014";
    display: inline-block;
    position: absolute;
    left: 0;
  }
`;
export const UnorderedList = ({ listItems }) => (<ul className={unorderedList}>
    {listItems.map(i => (<li className={unorderedListItem} key={i}>
        {i}
      </li>))}
  </ul>);
export const OrderedList = ({ listItems }) => (<ol className={orderedList}>
    {listItems.map(i => (<li className={orderedListItem} key={i}>
        {i}
      </li>))}
  </ol>);
export const DefinitionList = ({ listItems }) => (<dl className={definitionList}>
    {listItems.map(i => (<dt className={definitionListItem} key={i}>
        {i}
      </dt>))}
  </dl>);
/** Table */
export const tableWrapper = css `
  overflow-x: auto;
  overflow-y: hidden;

  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
`;
export const tableStyle = css `
  max-width: ${bp.maxWidth};
  width: 100%;
  display: table;
  border-collapse: collapse;
  ${sp.mv2};
  ${sp.pa0};
`;
export const theadStyle = css `
  display: table-header-group;
`;
export const rowStyle = css `
  display: table-row;
  border-bottom: 1px solid ${greyColors["100"]};
  &:hover {
    background-color: ${greyColors["50"]};
  }
`;
export const cellStyle = css `
  ${paragraph};
  color: ${greyColors["700"]};
  display: table-cell;
  font-size: 0.8rem;
  line-height: 1;
  padding: 0.9375rem 0.5625rem;
  text-align: right;
  vertical-align: top;
  white-space: nowrap;
  ${bp.medium `
    font-size: 1rem;
    line-height: 1.6875;
  `};
  &:first-child {
    background-color: #fff;
    text-align: left; 
    position: absolute;
    width: 20em;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:first-child + td {
    padding-left: 21em;
  } 
`;
export const headerStyle = css `
  ${cellStyle};
  ${strong};
  font-size: 0.9rem;
  ${bp.medium `
    font-size: 1rem;
    line-height: 1.6875;
  `}; 
`;
export const Table = ({ headers, rows }) => (<div className={tableWrapper}>
    <table className={tableStyle}>
      {headers && (<thead className={theadStyle}>
          <tr className={rowStyle}>
            {headers.map((h, i) => (<th className={headerStyle} key={`${h}-${i}`}>
                {h}
              </th>))}
          </tr>
        </thead>)}
      <tbody>
        {rows.map((row, i) => {
    return (<tr className={rowStyle} key={`${row[0]}-${i}`}>
              {row.map((cell, i) => (<td className={cellStyle} key={`${cell}-${i}`} title={cell}>
                  {cell}
                </td>))}
            </tr>);
})}
      </tbody>
    </table>
  </div>);



// WEBPACK FOOTER //
// ./src/theme/text.tsx